
/* ═══════════════════════════════════════════════════
   DATA TREES
═══════════════════════════════════════════════════ */
const TREES = {

/* ── MODULE 1 : RÉGLEMENTAIRE ── */
reglem:{
  label:'⚖️ Réglementaire',color:'#1464A0',
  questions:[
    {id:'r0',
     text:'Votre recherche implique-t-elle directement des personnes vivantes ?',
     hint:'Si vous exploitez uniquement des données déjà anonymisées (bases publiques, archives sans contact patient), répondez Non.',
     opts:[
       {l:'Oui — des participants sont impliqués',ic:'👤',nx:'r1'},
       {l:'Non — données anonymisées sans contact humain',ic:'🗄️',nx:'RES_hors'}
     ]},
    {id:'r1',
     text:'Votre recherche comporte-t-elle des procédures s\'ajoutant aux soins habituels ?',
     hint:'Procédures ajoutées = examens supplémentaires, traitements expérimentaux, prélèvements additionnels, questionnaires spécifiques à la recherche.',
     opts:[
       {l:'Oui — des actes ou procédures s\'ajoutent aux soins',ic:'💉',nx:'r2'},
       {l:'Non — collecte de données uniquement issues des soins courants',ic:'📂',nx:'RES_riph3obs'}
     ]},
    {id:'r2',
     text:'Quel produit ou technique fait l\'objet principal de votre recherche ?',
     hint:'Choisissez la catégorie la plus proche du produit / de la technique évalué(e).',
     opts:[
       {l:'Médicament sans AMM ou hors indication AMM',ic:'💊',s:'Ex : essai de Phase I/II, usage compassionnel, ATU/AAP',nx:'RES_riph1'},
       {l:'Médicament avec AMM dans ses indications',ic:'✅',s:'Médicament autorisé utilisé conformément à son AMM',nx:'r3'},
       {l:'Dispositif médical non marqué CE ou hors notice',ic:'🔬',s:'DM expérimental ou utilisé hors conditions d\'utilisation',nx:'RES_riph1'},
       {l:'Dispositif médical marqué CE, conforme notice',ic:'⚙️',s:'DM autorisé utilisé conformément',nx:'r3'},
       {l:'Nouvelle technique chirurgicale (non validée)',ic:'🏥',s:'Technique innovante, première utilisation',nx:'RES_riph1'},
       {l:'Autre — questionnaire, TCC, prise en charge, données physio…',ic:'📝',s:'Aucun médicament/DM expérimental',nx:'r3'}
     ]},
    {id:'r3',
     text:'Les procédures ajoutées présentent-elles un risque ou une contrainte pour les participants ?',
     hint:'Comparez vos procédures à la liste officielle RIPH2 (arrêté Legifrance). Si votre procédure y figure : RIPH2. Si elle est plus invasive : RIPH1.',
     opts:[
       {l:'Aucune contrainte ou risque significatif pour les participants',ic:'🟢',nx:'RES_riph3'},
       {l:'Procédure dans la liste RIPH2 — risque minimal',ic:'🟡',s:'Ex : ECG, EEG, prise de sang supplémentaire, questionnaire, spirométrie',nx:'RES_riph2'},
       {l:'Procédure invasive hors liste RIPH2',ic:'🔴',s:'Ex : biopsie, acte chirurgical, franchissement barrière cutanée',nx:'RES_riph1'}
     ]}
  ],
  results:{
    RES_hors:{
      cls:'hors',cat:'Hors champ Loi Jardé',
      title:'Recherche sur données anonymisées',
      sum:'Votre recherche ne relève pas du champ d\'application de la Loi Jardé (L. 1121-1 CSP). Elle porte exclusivement sur des données anonymisées ou des collections biologiques sans contact direct avec des personnes vivantes.',
      mon:null,
      steps:[
        {ic:'🔐',n:'CNIL — anonymisation vérifiée',d:'Documenter le processus d\'anonymisation irréversible. Référentiel CNIL applicable (MR-004 ou déclaration simplifiée).',req:true},
        {ic:'📋',n:'Comité d\'éthique (recommandé)',d:'Consultation éthique conseillée même si non obligatoire, notamment pour publication.',req:false},
        {ic:'📁',n:'Archivage sécurisé des données',d:'Conservation sécurisée selon les durées légales (code de la recherche).',req:true}
      ],
      refs:[
        {t:'Code de la santé publique L.1121-1',u:'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000025441587'},
        {t:'CNIL — Données de santé',u:'https://www.cnil.fr/fr/les-donnees-de-sante'}
      ]
    },
    RES_riph3obs:{
      cls:'riph3',cat:'RIPH Catégorie 3',
      title:'Non interventionnelle — Données soins courants',
      sum:'Votre recherche est non interventionnelle : elle exploite des données déjà collectées dans le cadre du soin (dossier médical, imagerie de routine…), sans procédure supplémentaire. Elle relève de la Catégorie 3 de la Loi Jardé.',
      mon:'light',
      steps:[
        {ic:'⚖️',n:'Comité de Protection des Personnes (CPP)',d:'Avis CPP obligatoire. Désignation par tirage au sort national (portail SI PGREC).',req:true},
        {ic:'🔐',n:'CNIL — MR-003 (données de santé)',d:'Engagement de conformité MR-003 pour recherches n\'impliquant pas la personne humaine, ou MR-001 selon profil.',req:true},
        {ic:'📝',n:'Information des participants',d:'Note d\'information obligatoire. La non-opposition suffit pour RIPH3 (pas de consentement signé exigé).',req:true},
        {ic:'📋',n:'Enregistrement registre national (RNSR / ClinicalTrials.gov)',d:'Enregistrement recommandé avant le début de l\'étude.',req:false},
        {ic:'📁',n:'Archivage (15 ans minimum)',d:'Conservation des documents essentiels selon durées réglementaires.',req:true}
      ],
      refs:[
        {t:'Loi Jardé — Legifrance',u:'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000025441587'},
        {t:'CNIL MR-003',u:'https://www.cnil.fr/fr/declaration/mr-003-recherches-nimpliquant-pas-la-personne-humaine'}
      ]
    },
    RES_riph3:{
      cls:'riph3',cat:'RIPH Catégorie 3',
      title:'Interventionnelle à risque négligeable',
      sum:'Votre recherche comporte des procédures ne présentant aucun risque ni contrainte significatifs pour les participants. Elle relève de la Catégorie 3 de la Loi Jardé.',
      mon:'light',
      steps:[
        {ic:'⚖️',n:'Comité de Protection des Personnes (CPP)',d:'Avis CPP obligatoire. Tirage au sort national.',req:true},
        {ic:'🔐',n:'CNIL — MR-003',d:'Engagement de conformité CNIL MR-003.',req:true},
        {ic:'📝',n:'Non-opposition écrite des participants',d:'Recueil de non-opposition obligatoire, remise de la note d\'information.',req:true},
        {ic:'📋',n:'Enregistrement ClinicalTrials.gov',d:'Recommandé avant toute première inclusion.',req:false},
        {ic:'📁',n:'Archivage documents essentiels',d:'Minimum 15 ans selon réglementation française.',req:true}
      ],
      refs:[
        {t:'Loi Jardé — Legifrance',u:'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000025441587'}
      ]
    },
    RES_riph2:{
      cls:'riph2',cat:'RIPH Catégorie 2',
      title:'Interventionnelle à risque minime',
      sum:'Votre recherche implique des procédures à risque minime figurant dans la liste de l\'arrêté ministériel. Elle relève de la Catégorie 2 de la Loi Jardé, avec des exigences réglementaires renforcées par rapport à la RIPH3.',
      mon:'moderate',
      steps:[
        {ic:'⚖️',n:'Comité de Protection des Personnes (CPP)',d:'Avis CPP obligatoire par tirage au sort. Délai d\'instruction : 45 jours.',req:true},
        {ic:'🏥',n:'ANSM — Déclaration ou autorisation',d:'Requis si médicament (même AMM utilisé dans essai) ou dispositif médical impliqué dans l\'intervention.',req:true},
        {ic:'🔐',n:'CNIL — MR-001 ou MR-003',d:'MR-001 si essai clinique avec médicament/DM. MR-003 sinon. Désigner un DPO si nécessaire.',req:true},
        {ic:'✍️',n:'Consentement éclairé écrit',d:'Consentement signé obligatoire avant toute procédure, y compris de screening.',req:true},
        {ic:'📋',n:'Enregistrement ClinicalTrials.gov',d:'Enregistrement obligatoire avant la première inclusion.',req:true},
        {ic:'📦',n:'Assurance promoteur (L. 1121-10 CSP)',d:'Couverture assurantielle obligatoire avant tout démarrage.',req:true},
        {ic:'📁',n:'Archivage (15 ans minimum)',d:'Documents essentiels conservés 15 ans après fin d\'étude.',req:true}
      ],
      refs:[
        {t:'Loi Jardé — Legifrance',u:'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000025441587'},
        {t:'ANSM — Recherche Clinique',u:'https://ansm.sante.fr/activites/autorisation-des-recherches-cliniques'}
      ]
    },
    RES_riph1:{
      cls:'riph1',cat:'RIPH Catégorie 1 — Essai Clinique',
      title:'Essai clinique interventionnel (Règl. UE 536/2014)',
      sum:'Votre recherche est un essai clinique interventionnel à risque significatif ou impliquant un produit expérimental. Elle relève de la Catégorie 1 de la Loi Jardé et du Règlement Européen 536/2014 pour les médicaments. Application complète des BPC ICH E6(R3) obligatoire.',
      mon:'full',
      steps:[
        {ic:'⚖️',n:'Comité de Protection des Personnes (CPP)',d:'Avis CPP obligatoire via le portail CTIS (médicaments) ou SI PGREC. Délai : 30 jours (médicaments) / 45 jours (autres).',req:true},
        {ic:'🏥',n:'ANSM — Autorisation de l\'essai',d:'Pour médicaments : soumission via portail CTIS (Règl. UE 536/2014). Pour DM : autorisation ANSM dédiée.',req:true},
        {ic:'🔐',n:'CNIL — MR-001',d:'Engagement de conformité au référentiel MR-001 (essais cliniques). Désignation DPO recommandée.',req:true},
        {ic:'✍️',n:'Consentement éclairé écrit et signé',d:'Avant toute procédure liée à la recherche, y compris le screening.',req:true},
        {ic:'🌍',n:'Enregistrement CTIS + ClinicalTrials.gov',d:'Enregistrement CTIS obligatoire pour essais médicaments UE. ClinicalTrials.gov pour publication internationale.',req:true},
        {ic:'📦',n:'Assurance promoteur (L. 1121-10)',d:'Assurance RC obligatoire couvrant le promoteur, l\'investigateur et les participants.',req:true},
        {ic:'⚡',n:'Pharmacovigilance — EIG / SUSAR',d:'EIG → promoteur 24h → ANSM 7j (décès/pronostic vital) ou 15j. Rapport SUSAR à ANSM et CPP.',req:true},
        {ic:'📁',n:'Trial Master File (TMF)',d:'Mise en place du TMF dès le démarrage. Structure ICH E6(R3). Archivage 25 ans.',req:true},
        {ic:'📊',n:'Plan de monitoring (proportionnel au risque)',d:'Plan de monitoring formalisé avant démarrage. Combinaison monitoring centralisé + visites sur site selon risque.',req:true},
        {ic:'📋',n:'Rapport final de l\'essai (CSR)',d:'Clinical Study Report à soumettre à l\'ANSM dans les 12 mois suivant la fin de l\'essai.',req:true}
      ],
      refs:[
        {t:'Loi Jardé — Legifrance',u:'https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000025441587'},
        {t:'BPC ICH E6(R3)',u:'https://database.ich.org/sites/default/files/ICH_E6%28R3%29_Step4_FinalGuideline_2025_0106.pdf'},
        {t:'Règlement UE 536/2014 — CTIS',u:'https://www.ema.europa.eu/en/human-regulatory/research-development/clinical-trials/clinical-trials-regulation'},
        {t:'ANSM — Essais cliniques',u:'https://ansm.sante.fr'}
      ]
    }
  }
},

/* ── MODULE 2 : MÉTHODOLOGIE ── */
methodo:{
  label:'📊 Méthodologie',color:'#8E44AD',
  questions:[
    {id:'m0',
     text:'Quel est l\'objectif principal de votre étude ?',
     hint:'L\'objectif détermine le design méthodologique le plus adapté.',
     opts:[
       {l:'Évaluer l\'efficacité / l\'effet d\'une intervention',ic:'🎯',nx:'m1'},
       {l:'Décrire une population, une prévalence ou un phénomène',ic:'📝',nx:'m_desc'},
       {l:'Identifier des facteurs pronostiques ou un risque',ic:'📈',nx:'m_prog'},
       {l:'Valider un outil ou test diagnostique',ic:'🔬',nx:'m_diag'}
     ]},
    {id:'m1',
     text:'Contrôlez-vous l\'attribution du traitement ?',
     hint:'La randomisation est le gold standard pour minimiser les biais de sélection et établir une relation de causalité.',
     opts:[
       {l:'Oui — randomisation prévue (RCT)',ic:'🎲',nx:'m_rct'},
       {l:'Non — étude observationnelle analytique',ic:'👁️',nx:'m_obs'}
     ]},
    {id:'m_rct',
     text:'Quel design randomisé choisissez-vous ?',
     hint:'Le choix dépend de votre question clinique, de la durée de l\'effet et des ressources disponibles.',
     opts:[
       {l:'Parallèle — 2 groupes ou plus simultanés',ic:'⬌',s:'Design le plus courant, puissant',nx:'RES_m_rct_para'},
       {l:'Croisé (crossover) — le patient reçoit les 2 traitements successivement',ic:'🔄',s:'Idéal si pathologie stable, wash-out nécessaire',nx:'RES_m_rct_cross'},
       {l:'Factoriel — plusieurs questions testées simultanément',ic:'⊞',s:'2 facteurs dans un seul essai',nx:'RES_m_rct_fact'},
       {l:'En cluster (grappes) — randomisation par groupe (centre, médecin)',ic:'🏥',s:'Prévention de la contamination',nx:'RES_m_rct_clust'}
     ]},
    {id:'m_obs',
     text:'Quel design observationnel ?',
     hint:'Le sens temporel (prospectif vs rétrospectif) et la présence d\'un groupe contrôle définissent le design.',
     opts:[
       {l:'Cohorte prospective — suivi dans le temps vers l\'outcome',ic:'➡️',nx:'RES_m_cohort'},
       {l:'Cas-témoins — part de l\'outcome, remonte à l\'exposition',ic:'↔️',nx:'RES_m_castemp'},
       {l:'Transversale — mesure à un instant T',ic:'📸',nx:'RES_m_transv'}
     ]},
    {id:'m_desc',
     text:'Quel type d\'étude descriptive ?',hint:'',
     opts:[
       {l:'Épidémiologique — incidence, prévalence populationnelle',ic:'🌍',nx:'RES_m_epi'},
       {l:'Registre ou cohorte de pratique courante (RWE)',ic:'📋',nx:'RES_m_registre'}
     ]},
    {id:'m_prog',
     text:'Quel type d\'analyse pronostique ?',hint:'',
     opts:[
       {l:'Identification de facteurs pronostiques (modèle multivarié)',ic:'📉',nx:'RES_m_progn'},
       {l:'Développement ou validation d\'un score prédictif',ic:'🎯',nx:'RES_m_score'}
     ]},
    {id:'m_diag',
     text:'Type de validation diagnostique ?',hint:'',
     opts:[
       {l:'Précision diagnostique — sensibilité / spécificité vs gold standard',ic:'🔬',nx:'RES_m_diagacc'},
       {l:'Accord inter-observateurs (kappa, ICC)',ic:'🤝',nx:'RES_m_kappa'}
     ]}
  ],
  results:{
    RES_m_rct_para:{
      cls:'methodo',cat:'Essai Randomisé Contrôlé — Design Parallèle',
      title:'RCT Parallèle (niveau de preuve 1)',
      sum:'Le design de référence pour démontrer une relation de causalité. Deux groupes (ou plus) sont randomisés simultanément. Niveau de preuve le plus élevé selon GRADE. Recommandé par les HAS, EMA et ICH E9.',
      mon:null,
      steps:[
        {ic:'📐',n:'Hypothèse PICO bien définie',d:'Population – Intervention – Comparateur – Outcome. L\'objectif principal doit être unique et pré-spécifié.',req:true},
        {ic:'🧮',n:'Calcul d\'effectif (puissance ≥80%, α=5%)',d:'Basé sur la différence cliniquement pertinente minimale (MCID), l\'écart-type estimé, α=0,05 bilatéral, puissance ≥80%.',req:true},
        {ic:'🎲',n:'Randomisation centralisée et masquée',d:'Blocs permutés ou stratifiée par facteurs pronostiques. IWRS électronique recommandé. Génération et allocation séparées.',req:true},
        {ic:'🙈',n:'Définir le niveau d\'insu (aveugle)',d:'Double aveugle > simple aveugle > ouvert. Justifier si ouvert. Procédure de levée d\'insu documentée.',req:true},
        {ic:'📊',n:'Plan d\'analyse statistique (SAP) finalisé avant déverrouillage',d:'Critère principal, analyses secondaires, gestion des données manquantes, population ITT/PP définie a priori.',req:true},
        {ic:'📋',n:'Enregistrement prospectif (avant 1ère inclusion)',d:'Enregistrement sur ClinicalTrials.gov, CTIS ou ISRCTN obligatoire avant toute inclusion.',req:true},
        {ic:'📝',n:'Rapport CONSORT',d:'Suivre la checklist CONSORT 2010 pour la rédaction et la soumission.',req:false}
      ]
    },
    RES_m_rct_cross:{
      cls:'methodo',cat:'Essai Randomisé — Design Croisé',
      title:'RCT Crossover (chaque patient = son propre contrôle)',
      sum:'Chaque participant reçoit successivement les traitements A et B (ou B puis A). Réduit significativement le nombre de sujets nécessaires. Uniquement applicable aux pathologies stables avec effet réversible.',
      mon:null,
      steps:[
        {ic:'🔄',n:'Période de wash-out suffisante',d:'Durée ≥5 demi-vies du produit. Documenter la disparition des effets biologiques.',req:true},
        {ic:'⚖️',n:'Test d\'effet carry-over obligatoire',d:'Vérifier l\'absence d\'effet résiduel entre les 2 périodes (test de Grizzle).',req:true},
        {ic:'🎲',n:'Séquences équilibrées AB/BA',d:'Randomisation au niveau patient selon les séquences. Équilibre des séquences contrôlé.',req:true},
        {ic:'📈',n:'Analyse mixte avec effets période et séquence',d:'Modèle linéaire mixte tenant compte de la structure longitudinale des données.',req:true},
        {ic:'⚠️',n:'Critères d\'éligibilité stricts',d:'Pathologie stable, pas de guérison possible, efficacité mesurable de façon répétée.',req:true}
      ]
    },
    RES_m_rct_fact:{
      cls:'methodo',cat:'Essai Randomisé — Design Factoriel',
      title:'RCT Factoriel (2 questions, 1 essai)',
      sum:'Permet de tester 2 interventions simultanément dans 4 bras (A seul / B seul / A+B / placebo). Efficace en termes de ressources. Mais l\'interaction entre les facteurs doit être anticipée.',
      mon:null,
      steps:[
        {ic:'⊞',n:'4 bras clairement définis',d:'A seul / B seul / A+B / aucun traitement — randomisation 1:1:1:1.',req:true},
        {ic:'⚠️',n:'Test d\'interaction en analyse primaire',d:'L\'interaction entre les deux facteurs doit être testée en premier. Si interaction significative : analyser chaque facteur séparément.',req:true},
        {ic:'🧮',n:'Calcul d\'effectif avec hypothèse d\'absence d\'interaction',d:'Si interaction non attendue : puissance calculée sur chaque facteur séparément (doublement de la taille).',req:true}
      ]
    },
    RES_m_rct_clust:{
      cls:'methodo',cat:'Essai Randomisé — Design en Cluster',
      title:'RCT en Cluster (randomisation par grappes)',
      sum:'L\'unité de randomisation est le groupe (hôpital, service, médecin généraliste) et non l\'individu. Utilisé quand la contamination entre sujets est inévitable. Nécessite un coefficient de corrélation intraclasse (ICC).',
      mon:null,
      steps:[
        {ic:'🏥',n:'Définir l\'unité de cluster',d:'Le cluster (centre, praticien, service) est l\'unité randomisée. Tous les individus du cluster reçoivent la même intervention.',req:true},
        {ic:'📊',n:'ICC (coefficient corrélation intraclasse)',d:'Estimer l\'ICC a priori (littérature ou pilote). L\'ICC gonfle la taille d\'échantillon nécessaire.',req:true},
        {ic:'🔢',n:'Nombre de clusters ≥10 par bras',d:'Minimum recommandé pour assurer la puissance. Idéalement ≥20 clusters/bras.',req:true},
        {ic:'📈',n:'Analyse GEE ou modèle mixte hiérarchique',d:'Tenir compte de la structure emboîtée individus/clusters dans toutes les analyses.',req:true},
        {ic:'📝',n:'Rapport CONSORT — extension cluster',d:'Utiliser l\'extension CONSORT pour essais en cluster (Donner et al.).',req:false}
      ]
    },
    RES_m_cohort:{
      cls:'methodo',cat:'Étude Observationnelle — Cohorte',
      title:'Cohorte Prospective (niveau de preuve 2)',
      sum:'Suivi dans le temps de sujets exposés vs non exposés. Permet d\'estimer l\'incidence et des associations causales. Niveau de preuve 2 (après RCT). Sensible aux biais de confusion.',
      mon:null,
      steps:[
        {ic:'📅',n:'Cohorte d\'entrée clairement définie',d:'Critères d\'inclusion, date d\'entrée en cohorte, exposition mesurée à l\'entrée ou au cours du suivi.',req:true},
        {ic:'🕐',n:'Durée de suivi et attrition contrôlée',d:'Perdus de vue <20% recommandé. Analyse de sensibilité sur impact des données manquantes.',req:true},
        {ic:'🔄',n:'Gestion des facteurs confondants',d:'Analyse multivariée (Cox, régression logistique), score de propension si nécessaire.',req:true},
        {ic:'📊',n:'Critère principal pré-spécifié',d:'Critère de jugement défini avant la collecte de données.',req:true},
        {ic:'📝',n:'Rapport STROBE',d:'Checklist STROBE pour études observationnelles (cohorte).',req:false}
      ]
    },
    RES_m_castemp:{
      cls:'methodo',cat:'Étude Observationnelle — Cas-témoins',
      title:'Cas-témoins (niveau de preuve 3)',
      sum:'Part du critère de jugement (les cas) pour remonter à l\'exposition. Très efficace pour les maladies rares. Odds Ratio comme mesure d\'association. Sensible au biais de rappel.',
      mon:null,
      steps:[
        {ic:'🎯',n:'Définition précise des cas et des témoins',d:'Critères de cas stricts. Les témoins issus de la même population source que les cas.',req:true},
        {ic:'⚖️',n:'Appariement cas-témoins',d:'Apparier sur âge, sexe, centre pour contrôler les confondants. Ratio cas:témoins ≥1:2 recommandé.',req:true},
        {ic:'📊',n:'Odds Ratio avec IC 95%',d:'OR en analyse principale. Régression logistique conditionnelle si cas appariés.',req:true},
        {ic:'⚠️',n:'Contrôle du biais de rappel',d:'Utiliser des sources objectives (dossiers, bases médicales) en priorité sur les auto-déclarations.',req:true},
        {ic:'📝',n:'Rapport STROBE — extension cas-témoins',d:'Checklist STROBE adaptée aux cas-témoins.',req:false}
      ]
    },
    RES_m_transv:{
      cls:'methodo',cat:'Étude Observationnelle — Transversale',
      title:'Étude Transversale (niveau de preuve 4)',
      sum:'Photographie d\'une population à un instant T. Permet d\'estimer la prévalence et des associations. La causalité est limitée car exposition et outcome sont mesurés simultanément.',
      mon:null,
      steps:[
        {ic:'📸',n:'Population source et échantillonnage définis',d:'Échantillonnage aléatoire si possible pour représentativité.',req:true},
        {ic:'📊',n:'Prévalence brute + IC 95%',d:'Prévalence avec intervalles de confiance. Standardisation si comparaison de populations.',req:true},
        {ic:'⚠️',n:'Biais de prévalence-incidence',d:'Prudence pour maladies à issue rapide (décès, guérison rapide) qui biaisent la prévalence.',req:true},
        {ic:'📝',n:'Rapport STROBE',d:'Checklist STROBE pour études transversales.',req:false}
      ]
    },
    RES_m_epi:{
      cls:'methodo',cat:'Épidémiologie Descriptive',
      title:'Étude épidémiologique — Incidence/Prévalence',
      sum:'Quantification d\'un phénomène de santé dans une population définie. Données fondamentales pour la santé publique. Peut s\'appuyer sur des bases de données médico-administratives (SNDS).',
      mon:null,
      steps:[
        {ic:'🌍',n:'Population et zone géographique définies',d:'Source de données (SNDS, registres, cohortes existantes). Période d\'observation précisée.',req:true},
        {ic:'📊',n:'Taux standardisés (âge, sexe)',d:'Standardisation directe ou indirecte. Référence nationale ou européenne.',req:true},
        {ic:'🔐',n:'Accès aux données (CNIL / CEREES / HDH)',d:'Demande d\'accès SNDS via INDS. Procédure CNIL si nécessaire.',req:true}
      ]
    },
    RES_m_registre:{
      cls:'methodo',cat:'RWE — Real World Evidence',
      title:'Registre / Cohorte de pratique courante',
      sum:'Collecte systématique de données en vie réelle. Complète les essais cliniques pour les données du monde réel (RWE). Fort intérêt pour les autorités de santé (HAS, EMA) en post-AMM.',
      mon:null,
      steps:[
        {ic:'📋',n:'Formulaire de collecte standardisé',d:'CRF ou questionnaire validé. Formation des équipes collectrices.',req:true},
        {ic:'🔐',n:'Gouvernance des données (CNIL, DPO)',d:'Plan de gestion des données. CNIL. Désignation DPO si requis. Charte de confidentialité.',req:true},
        {ic:'📊',n:'Assurance qualité des données',d:'Procédures de contrôle qualité, audit trail, clean-up régulier.',req:true},
        {ic:'📋',n:'Rapport RECORD (registres observationnels)',d:'Extension STROBE-RECORD pour études sur bases de données routinières.',req:false}
      ]
    },
    RES_m_progn:{
      cls:'methodo',cat:'Analyse Pronostique',
      title:'Modèle de facteurs pronostiques',
      sum:'Identification de variables associées à un pronostic (survie, rechute, réponse au traitement). Nécessite une cohorte bien définie avec follow-up suffisant. Rapporter selon TRIPOD.',
      mon:null,
      steps:[
        {ic:'📉',n:'Modèle de Cox ou régression logistique',d:'Modèle de Cox si critère temps-événement. Régression logistique si critère binaire. Résidus de Schoenfeld pour hypothèse de proportionnalité.',req:true},
        {ic:'⚖️',n:'Sélection des variables a priori (clinique)',d:'Lister les facteurs candidats sur base clinique et bibliographique. Éviter la sélection stepwise automatique.',req:true},
        {ic:'🔄',n:'Validation interne (bootstrap ou k-fold)',d:'Évaluer l\'optimisme du modèle. Shrinkage si surajustement.',req:true},
        {ic:'📝',n:'Rapport TRIPOD',d:'Checklist TRIPOD pour modèles pronostiques.',req:false}
      ]
    },
    RES_m_score:{
      cls:'methodo',cat:'Validation de Score Prédictif',
      title:'Validation externe d\'un score prédictif',
      sum:'Évaluation des performances d\'un score existant dans une nouvelle cohorte. La validation externe (cohorte différente de la dérivation) est impérative avant usage clinique.',
      mon:null,
      steps:[
        {ic:'🎯',n:'Discrimination (AUC / C-statistic)',d:'AUC ≥0.70 généralement considérée acceptable. IC 95% avec bootstrap.',req:true},
        {ic:'📐',n:'Calibration (Hosmer-Lemeshow ou calibration plot)',d:'Concordance entre probabilités prédites et observées. Calibration plot systématique.',req:true},
        {ic:'🔄',n:'Validation externe obligatoire',d:'Sur une cohorte indépendante de la cohorte de dérivation. Si multi-site, validation par site.',req:true},
        {ic:'📝',n:'Rapport TRIPOD',d:'Checklist TRIPOD+AI si score basé sur machine learning.',req:false}
      ]
    },
    RES_m_diagacc:{
      cls:'methodo',cat:'Étude Diagnostique',
      title:'Précision diagnostique (STARD)',
      sum:'Évaluation des performances d\'un nouveau test diagnostique vs gold standard de référence. Suivre les recommandations STARD (Standards for Reporting Diagnostic accuracy Studies).',
      mon:null,
      steps:[
        {ic:'🔬',n:'Gold standard défini a priori',d:'Référence appliquée de façon indépendante et aveugle au test évalué. Appliquée à tous les patients.',req:true},
        {ic:'📊',n:'Se, Sp, VPP, VPN avec IC 95%',d:'Sensibilité, Spécificité, Valeurs prédictives. IC 95% méthode Wilson. Courbe ROC avec AUC.',req:true},
        {ic:'⚠️',n:'Absence de biais de vérification',d:'Tous les patients doivent recevoir le gold standard, qu\'ils soient positifs ou négatifs au test évalué.',req:true},
        {ic:'📝',n:'Rapport STARD 2015',d:'Checklist STARD 2015 obligatoire pour publication.',req:false}
      ]
    },
    RES_m_kappa:{
      cls:'methodo',cat:'Étude de Concordance',
      title:'Accord inter-observateurs',
      sum:'Mesure de l\'accord entre deux (ou plusieurs) évaluateurs ou deux mesures répétées. Kappa pour variables catégorielles, ICC pour variables continues.',
      mon:null,
      steps:[
        {ic:'🤝',n:'Kappa de Cohen (variables catégorielles)',d:'κ <0.20 : faible / 0.21-0.40 : modéré / 0.41-0.60 : moyen / 0.61-0.80 : substantiel / >0.80 : presque parfait.',req:true},
        {ic:'📐',n:'ICC (variables continues)',d:'ICC >0.75 généralement considéré bon accord. IC 95% obligatoire.',req:true},
        {ic:'🔁',n:'Lectures en aveugle réciproque',d:'Chaque évaluateur lit sans connaître le jugement de l\'autre. Délai suffisant entre les deux lectures si même évaluateur (fiabilité intra-observateur).',req:true}
      ]
    }
  }
},

/* ── MODULE 3 : BPC / GCP R3 ── */
bpc:{
  label:'📋 BPC / GCP R3',color:'#C0392B',
  questions:[
    {id:'b0',
     text:'Qui est le promoteur de la recherche ?',
     hint:'Le promoteur (sponsor) est responsable de la mise en place, de la conduite et du financement de l\'étude. Il peut être institutionnel ou industriel.',
     opts:[
       {l:'Promoteur institutionnel (CHU, AP-HP, INSERM, Université, CLCC…)',ic:'🏥',nx:'b1'},
       {l:'Promoteur industriel (industrie pharmaceutique, biotech, medtech)',ic:'🏭',nx:'b1_ind'}
     ]},
    {id:'b1',
     text:'Quelle est la catégorie réglementaire de l\'étude ?',
     hint:'La catégorie conditionne les exigences BPC applicables selon ICH E6(R3) et la réglementation française.',
     opts:[
       {l:'RIPH1 — Essai clinique interventionnel',ic:'🔴',nx:'b2'},
       {l:'RIPH2 — Interventionnelle à risque minime',ic:'🟡',nx:'b2_r2'},
       {l:'RIPH3 — Non interventionnelle / observationnelle',ic:'🟢',nx:'b2_r3'}
     ]},
    {id:'b1_ind',
     text:'Phase de développement de l\'essai clinique ?',
     hint:'Les ressources de monitoring et la documentation augmentent avec la phase.',
     opts:[
       {l:'Phase I — Première administration humaine, PK/PD',ic:'1️⃣',nx:'b2'},
       {l:'Phase II — Preuve de concept, dose-réponse',ic:'2️⃣',nx:'b2'},
       {l:'Phase III — Essai pivot confirmateur (enregistrement)',ic:'3️⃣',nx:'b2'},
       {l:'Phase IV — Post-AMM, pharmaco-épidémiologie',ic:'4️⃣',nx:'b2_r2'}
     ]},
    {id:'b2',
     text:'L\'essai est-il multicentrique ?',
     hint:'Un essai multicentrique exige une coordination renforcée et un CTMS est fortement recommandé à partir de 5 centres.',
     opts:[
       {l:'Oui — plusieurs centres investigateurs',ic:'🌐',nx:'b3'},
       {l:'Non — monocentrique (un seul site)',ic:'🏠',nx:'b3_mono'}
     ]},
    {id:'b2_r2',
     text:'L\'étude est-elle multicentrique ?',hint:'',
     opts:[
       {l:'Oui — plusieurs centres',ic:'🌐',nx:'RES_b_r2_multi'},
       {l:'Non — monocentrique',ic:'🏠',nx:'RES_b_r2_mono'}
     ]},
    {id:'b2_r3',
     text:'Des données à caractère personnel sont-elles collectées ?',hint:'',
     opts:[
       {l:'Oui — données identifiantes ou pseudonymisées',ic:'🔐',nx:'RES_b_r3'},
       {l:'Non — données entièrement anonymisées',ic:'✅',nx:'RES_b_anon'}
     ]},
    {id:'b3',
     text:'Quel est le niveau de risque de l\'intervention ?',
     hint:'ICH E6(R3) préconise un monitoring PROPORTIONNEL AU RISQUE. Un médicament expérimental implique toujours un monitoring complet avec TMF structuré.',
     opts:[
       {l:'Élevé — médicament expérimental, acte invasif, chirurgie',ic:'🔴',nx:'RES_b_full_multi'},
       {l:'Modéré — médicament AMM hors indication, DM marqué CE',ic:'🟡',nx:'RES_b_mod_multi'}
     ]},
    {id:'b3_mono',
     text:'Quel est le niveau de risque de l\'intervention ?',hint:'',
     opts:[
       {l:'Élevé — médicament expérimental, acte invasif',ic:'🔴',nx:'RES_b_full_mono'},
       {l:'Modéré à faible — intervention à risque limité',ic:'🟡',nx:'RES_b_mod_mono'}
     ]}
  ],
  results:{
    RES_b_full_multi:{
      cls:'bpc',cat:'Monitoring Complet — RIPH1 Multicentrique',
      title:'Essai clinique RIPH1 Multicentrique — Plan BPC ICH E6(R3) complet',
      sum:'Application intégrale des BPC ICH E6(R3). Monitoring combiné sur site + centralisé, TMF électronique structuré, ISF par centre, CTMS fortement recommandé. Archivage 25 ans pour médicaments.',
      mon:'full',
      steps:[
        {ic:'📁',n:'TMF — Trial Master File (obligatoire)',d:'Structure selon DIA Reference Model ou ICH E6(R3) Annexe C. eTMF électronique fortement recommandé. Complétude vérifiée à chaque visite de monitoring. Archivage 25 ans.',req:true},
        {ic:'📂',n:'ISF — Investigator Site File (par centre)',d:'Miroir du TMF au niveau site. Contient : protocole, approbations, CV investigateurs, délégations de tâches, consentements, liste patients, journaux de dispensation.',req:true},
        {ic:'💻',n:'CTMS — Clinical Trial Management System',d:'Fortement recommandé (>5 centres). Gestion : recrutement, visites de monitoring, requêtes, paiements, médicament. Outils : Medidata CTMS, Veeva Vault, Oracle Siebel.',req:false},
        {ic:'📊',n:'EDC / eCRF avec audit trail',d:'Saisie électronique obligatoire pour monitoring centralisé efficace. Validation 21 CFR Part 11 ou ISO 27001 équivalent. Audit trail activé.',req:true},
        {ic:'🔍',n:'Monitoring sur site (SDV ciblé ou complet)',d:'Plan de monitoring formalisé avec fréquence des visites. SDV 100% sur données critiques (critère principal, EIG, consentements) ou SDV basé sur risque (RBM).',req:true},
        {ic:'🖥️',n:'Monitoring centralisé (obligatoire selon E6(R3))',d:'ICH E6(R3) exige la combinaison monitoring centralisé + sur site. Surveillance statistique : données aberrantes, tendances, signaux qualité, recrutement.',req:true},
        {ic:'📋',n:'Rapports de visites formalisés',d:'Rapport écrit après chaque visite (initiation, suivi, clôture) avec liste des actions correctives.',req:true},
        {ic:'⚡',n:'EIG / SUSAR — pharmacovigilance',d:'EIG → promoteur 24h / ANSM 7j (décès, pronostic vital) ou 15j / EudraCT ou CTIS. Rapport SUSAR à ANSM + CPP.',req:true},
        {ic:'📦',n:'Gestion du médicament expérimental (IMP)',d:'Traçabilité : réception, stockage (température), dispensation, retour/destruction. Réconciliation IMP obligatoire.',req:true},
        {ic:'🔐',n:'CNIL — MR-001',d:'Engagement de conformité MR-001. DPO conseillé. Data Processing Agreement si prestataires.',req:true}
      ]
    },
    RES_b_full_mono:{
      cls:'bpc',cat:'Monitoring Complet — RIPH1 Monocentrique',
      title:'Essai clinique RIPH1 Monocentrique — BPC ICH E6(R3)',
      sum:'Monitoring complet requis mais intensité adaptée au contexte monocentrique. TMF et ISF peuvent être fusionnés. Monitoring sur site facilité par la proximité, mais toujours documenté.',
      mon:'full',
      steps:[
        {ic:'📁',n:'TMF/ISF (fusionné si monocentrique)',d:'Un seul classeur TMF/ISF est acceptable en monocentrique. Structure simplifiée mais complète.',req:true},
        {ic:'📊',n:'eCRF ou CRF papier avec audit trail',d:'EDC recommandé. CRF papier acceptable si archivage sécurisé.',req:true},
        {ic:'🔍',n:'Monitoring sur site (visite initiation + suivi + clôture)',d:'Fréquence des visites selon risque et durée. Minimum : initiation, 1 visite de suivi et clôture.',req:true},
        {ic:'🖥️',n:'Monitoring à distance en complément',d:'Revue EDC à distance entre les visites sur site. Requêtes en ligne.',req:true},
        {ic:'⚡',n:'EIG / SUSAR',d:'Même délais et obligations que multicentrique.',req:true},
        {ic:'💻',n:'CTMS (optionnel)',d:'Peut faciliter la gestion même en monocentrique.',req:false}
      ]
    },
    RES_b_mod_multi:{
      cls:'bpc',cat:'Monitoring Proportionnel — RIPH1 Multicentrique Risque Modéré',
      title:'Monitoring proportionnel au risque — Multicentrique',
      sum:'Selon ICH E6(R3), le monitoring doit être adapté au risque réel. Pour un essai à risque modéré, la combinaison monitoring centralisé renforcé + visites sur site ciblées est recommandée.',
      mon:'moderate',
      steps:[
        {ic:'📁',n:'TMF (électronique recommandé)',d:'Structure TMF obligatoire. Peut être simplifiée. eTMF fortement recommandé.',req:true},
        {ic:'📂',n:'ISF par site',d:'Classeur investigateur à chaque centre.',req:true},
        {ic:'🖥️',n:'Monitoring centralisé renforcé',d:'Revue statistique régulière des données EDC. Détection anomalies, tendances. Requêtes en ligne.',req:true},
        {ic:'🔍',n:'Visites sur site ciblées',d:'Visite initiation + clôture obligatoires. Visites de suivi ciblées sur centres à risque élevé.',req:true},
        {ic:'📊',n:'EDC / eCRF',d:'Fortement recommandé pour le monitoring centralisé.',req:true},
        {ic:'💻',n:'CTMS recommandé',d:'Recommandé si ≥5 centres pour coordination.',req:false}
      ]
    },
    RES_b_mod_mono:{
      cls:'bpc',cat:'Monitoring Allégé — Monocentrique Risque Modéré',
      title:'Monitoring allégé — Monocentrique',
      sum:'Pour un essai monocentrique à risque modéré, le monitoring à distance peut être privilégié, complété par des visites sur site ciblées.',
      mon:'moderate',
      steps:[
        {ic:'📁',n:'TMF simplifié',d:'Documentation essentielle. Structure allégée acceptable pour monocentrique à risque modéré.',req:true},
        {ic:'🖥️',n:'Monitoring à distance (prioritaire)',d:'Revue EDC, requêtes en ligne, échanges par messagerie sécurisée.',req:true},
        {ic:'🔍',n:'Visites sur site (initiation + clôture minimum)',d:'Visite d\'initiation et clôture obligatoires. Visites de suivi selon risque constaté.',req:true},
        {ic:'📊',n:'CRF papier ou EDC',d:'Les deux sont acceptables selon ressources.',req:true}
      ]
    },
    RES_b_r2_multi:{
      cls:'bpc',cat:'Monitoring RIPH2 Multicentrique',
      title:'RIPH2 Multicentrique — BPC allégées',
      sum:'Les BPC s\'appliquent de façon adaptée aux RIPH2. Le monitoring est allégé mais documenté. L\'accent est mis sur la qualité des données et la protection des participants.',
      mon:'moderate',
      steps:[
        {ic:'📁',n:'TMF simplifié',d:'Documentation essentielle requise. Structure allégée possible.',req:true},
        {ic:'📂',n:'ISF par centre (recommandé)',d:'Classeur investigateur recommandé. Contient protocole, approbations, consentements, liste patients.',req:false},
        {ic:'🖥️',n:'Monitoring centralisé',d:'Revue des données à distance en priorité. Signaux qualité, suivi recrutement.',req:true},
        {ic:'🔍',n:'Visites sur site ciblées',d:'Initiation + clôture + sites identifiés à risque.',req:true},
        {ic:'💻',n:'CTMS ou outil de suivi',d:'Recommandé si ≥5 centres.',req:false},
        {ic:'📊',n:'eCRF recommandé',d:'Facilite le monitoring centralisé.',req:false}
      ]
    },
    RES_b_r2_mono:{
      cls:'bpc',cat:'Monitoring RIPH2 Monocentrique',
      title:'RIPH2 Monocentrique — Documentation allégée',
      sum:'Monitoring minimal. Focus sur les données critiques (consentements, critère principal) et la protection des données personnelles.',
      mon:'light',
      steps:[
        {ic:'📁',n:'Documentation locale (classeur)',d:'Classeur local avec documents essentiels. Pas de TMF formel obligatoire mais recommandé.',req:false},
        {ic:'🖥️',n:'Monitoring à distance (privilégié)',d:'Revue à distance des données. Visites sur site minimisées.',req:true},
        {ic:'🔍',n:'Visite initiation + clôture',d:'Minimum deux visites : initiation et clôture.',req:true},
        {ic:'📊',n:'CRF adapté (papier ou eCRF)',d:'Selon ressources disponibles.',req:true}
      ]
    },
    RES_b_r3:{
      cls:'bpc',cat:'Documentation RIPH3',
      title:'RIPH3 — Non interventionnelle : surveillance qualité',
      sum:'Les BPC s\'appliquent de façon allégée aux RIPH3. L\'accent est mis sur la protection des données personnelles et la qualité de la collecte.',
      mon:'light',
      steps:[
        {ic:'📋',n:'Plan de gestion des données (DMP)',d:'Protocole et Data Management Plan formalisés.',req:true},
        {ic:'🔐',n:'CNIL et protection des données',d:'MR-003 ou déclaration adaptée. DPO si nécessaire. Consentement ou non-opposition selon cas.',req:true},
        {ic:'📊',n:'Formulaire de collecte standardisé',d:'CRF ou questionnaire validé. Formation des équipes.',req:true},
        {ic:'📁',n:'Archivage selon durées légales',d:'15 ans minimum pour études RIPH3.',req:true},
        {ic:'🔍',n:'Audit qualité interne',d:'Vérification périodique de la cohérence et complétude des données.',req:false}
      ]
    },
    RES_b_anon:{
      cls:'bpc',cat:'Données Anonymisées',
      title:'Données anonymisées — Bonnes pratiques de gestion',
      sum:'Les BPC ICH E6(R3) ne s\'appliquent pas formellement aux données entièrement anonymisées. De bonnes pratiques de gestion des données s\'imposent néanmoins.',
      mon:null,
      steps:[
        {ic:'📊',n:'Plan de gestion des données',d:'Documentation de l\'origine, du traitement et de la chaîne de traitement des données.',req:true},
        {ic:'🔐',n:'Anonymisation vérifiée et documentée',d:'Processus d\'anonymisation irréversible documenté (critères CNIL, ISO 29101).',req:true},
        {ic:'📁',n:'Archivage sécurisé',d:'Conservation sécurisée des données brutes et analyses.',req:true}
      ]
    }
  }
}

}; // end TREES

/* ═══════════════════════════════════════════════════
   STATE
═══════════════════════════════════════════════════ */
let state = { mod:null, hist:[], qId:null };

const $mc = () => document.getElementById('mainContent');
const T  = () => TREES[state.mod];
const Q  = id => T().questions.find(q=>q.id===id);

function setTab(tab){
  document.querySelectorAll('.tab-btn').forEach(b=>b.classList.toggle('active',b.dataset.tab===tab));
  if(tab==='home'){ renderHome(); }
  else { startModule(tab); }
}

/* ─── HOME ─── */
function renderHome(){
  $mc().innerHTML=`
  <div class="home-screen anim">
    <div class="home-hero">
      <h1>Guidez votre <span>Recherche Clinique</span><br>étape par étape</h1>
      <p>Qualifiez réglementairement votre étude, choisissez votre design méthodologique et planifiez votre monitoring BPC selon ICH E6(R3) en quelques clics.</p>
    </div>
    <div class="module-cards">
      <div class="module-card" onclick="startModule('reglem')">
        <div class="card-icon" style="background:#EBF5FB">⚖️</div>
        <div class="card-title">Qualification Réglementaire</div>
        <div class="card-desc">Loi Jardé · CNIL · ANSM · CPP<br>Classification RIPH 1 / 2 / 3</div>
      </div>
      <div class="module-card" onclick="startModule('methodo')">
        <div class="card-icon" style="background:#F5EEF8">📊</div>
        <div class="card-title">Méthodologie</div>
        <div class="card-desc">Design d'étude · Randomisation<br>Calcul d'effectif · Analyse statistique</div>
      </div>
      <div class="module-card" onclick="startModule('bpc')">
        <div class="card-icon" style="background:#FDEDEC">📋</div>
        <div class="card-title">BPC / GCP ICH E6(R3)</div>
        <div class="card-desc">Monitoring proportionnel<br>TMF · ISF · CTMS · EDC</div>
      </div>
    </div>
    <button class="start-btn" onclick="startModule('reglem')">🚀 Commencer l'évaluation complète →</button>
    <p style="text-align:center;font-size:11px;color:var(--muted);margin-top:18px">
      Basé sur : Loi Jardé (2012) · ICH E6(R3) 2025 · Règlement UE 536/2014 · CNIL MR-001/003
    </p>
  </div>`;
}

/* ─── QUESTION ─── */
function startModule(mod){
  state={mod,hist:[],qId:null};
  document.querySelectorAll('.tab-btn').forEach(b=>b.classList.toggle('active',b.dataset.tab===mod));
  showQ(T().questions[0].id);
}

function showQ(id){
  const q=Q(id);
  if(!q){renderHome();return;}
  state.qId=id;
  const all=T().questions.length;
  const pct=Math.round((state.hist.length/all)*100);
  $mc().innerHTML=`
  <div class="anim">
    <div class="q-progress">
      <span class="prog-label">${T().label}</span>
      <div class="prog-bar-wrap"><div class="prog-bar-fill" style="width:${pct}%"></div></div>
      <span class="prog-steps">${state.hist.length+1} / ${all}</span>
    </div>
    <div class="q-body">
      <div class="q-mod-badge" style="background:${T().color}18;color:${T().color}">${T().label}</div>
      <div class="q-num">Question ${state.hist.length+1}</div>
      <div class="q-text">${q.text}</div>
      ${q.hint?`<div class="q-hint">ℹ️ ${q.hint}</div>`:''}
      <div class="options-grid">
        ${q.opts.map(o=>`
          <button class="opt-btn" onclick="pick('${o.nx}')">
            <div class="opt-icon">${o.ic||'▸'}</div>
            <div class="opt-main">
              <strong>${o.l}</strong>
              ${o.s?`<small>${o.s}</small>`:''}
            </div>
            <div class="opt-arr">›</div>
          </button>`).join('')}
      </div>
      <div class="nav-row">
        ${state.hist.length>0?`<button class="btn-back" onclick="goBack()">← Retour</button>`:''}
        <button class="btn-back" onclick="renderHome();document.querySelectorAll('.tab-btn').forEach(b=>b.classList.toggle('active',b.dataset.tab==='home'))" style="margin-left:auto">🏠 Accueil</button>
      </div>
    </div>
  </div>`;
}

function pick(nx){
  state.hist.push(state.qId);
  if(nx.startsWith('RES_')){ showResult(nx); }
  else { showQ(nx); }
}

function goBack(){
  if(!state.hist.length){renderHome();return;}
  showQ(state.hist.pop());
}

/* ─── RESULT ─── */
const MON_LABEL={
  full:'🔴 Monitoring complet (ICH E6(R3) — proportionnel au risque élevé)',
  moderate:'🟡 Monitoring allégé — proportionnel au risque modéré',
  light:'🟢 Surveillance qualité minimale'
};

const MON_GRIDS={
  full:`<div class="mon-section">
    <div class="section-title">🔍 Plan de Monitoring BPC — ICH E6(R3)</div>
    <div class="mon-grid">
      <div class="mon-card hi"><div class="mon-ico">📁</div><div class="mon-title">TMF — Trial Master File</div><div class="mon-desc">Obligatoire. Structure DIA/TMF-RM ou ICH E6(R3) Annexe C. eTMF électronique fortement recommandé. Complétude vérifiée à chaque visite. Archivage 25 ans (médicaments).</div></div>
      <div class="mon-card hi"><div class="mon-ico">📂</div><div class="mon-title">ISF — Investigator Site File</div><div class="mon-desc">Un ISF par site investigateur. Miroir du TMF. Contient : protocole, approbations CPP/ANSM, CV, délégations, consentements originaux, liste patients, journaux IMP.</div></div>
      <div class="mon-card hi"><div class="mon-ico">🖥️</div><div class="mon-title">Monitoring Centralisé (obligatoire E6(R3))</div><div class="mon-desc">ICH E6(R3) impose la combinaison monitoring centralisé + sur site. Surveillance statistique des données : anomalies, tendances, qualité, signaux sécurité.</div></div>
      <div class="mon-card"><div class="mon-ico">🔍</div><div class="mon-title">Monitoring Sur Site (SDV)</div><div class="mon-desc">SDV 100% sur données critiques ou SDV basé sur risque (RBM). Rapport de visite formalisé. Visites : initiation + suivi (fréquence/risque) + clôture.</div></div>
      <div class="mon-card"><div class="mon-ico">💻</div><div class="mon-title">CTMS</div><div class="mon-desc">Fortement recommandé (multicentrique ≥5 sites). Gestion : recrutement, planning visites, requêtes, paiements, stock IMP. Ex : Medidata, Veeva Vault, Ennov.</div></div>
      <div class="mon-card"><div class="mon-ico">📊</div><div class="mon-title">EDC / eCRF</div><div class="mon-desc">Saisie électronique avec audit trail activé. Validation 21 CFR Part 11 (FDA) ou équivalent. Facilite le monitoring centralisé et les requêtes en temps réel.</div></div>
    </div></div>`,
  moderate:`<div class="mon-section">
    <div class="section-title">🔍 Monitoring Proportionnel — ICH E6(R3)</div>
    <div class="mon-grid">
      <div class="mon-card hi"><div class="mon-ico">📁</div><div class="mon-title">TMF (simplifié)</div><div class="mon-desc">Documentation essentielle obligatoire. Structure allégée acceptable. eTMF recommandé.</div></div>
      <div class="mon-card hi"><div class="mon-ico">🖥️</div><div class="mon-title">Monitoring Centralisé (prioritaire)</div><div class="mon-desc">Revue à distance des données EDC. Requêtes en ligne. Signaux qualité. Visites sur site ciblées sur centres à risque.</div></div>
      <div class="mon-card"><div class="mon-ico">📂</div><div class="mon-title">ISF par site</div><div class="mon-desc">Classeur investigateur avec au minimum : protocole, approbations, consentements, liste patients.</div></div>
      <div class="mon-card"><div class="mon-ico">💻</div><div class="mon-title">CTMS (optionnel)</div><div class="mon-desc">Recommandé si ≥5 centres. Peut être remplacé par tableau de bord adapté si ressources limitées.</div></div>
    </div></div>`,
  light:`<div class="mon-section">
    <div class="section-title">🔍 Surveillance Qualité Allégée</div>
    <div class="mon-grid">
      <div class="mon-card"><div class="mon-ico">📋</div><div class="mon-title">Documentation minimale</div><div class="mon-desc">Classeur local avec protocole, approbations, consentements / non-opposition et données. Pas de TMF formel mais recommandé.</div></div>
      <div class="mon-card"><div class="mon-ico">🖥️</div><div class="mon-title">Vérification à distance</div><div class="mon-desc">Revue périodique des données à distance. Visites sur site limitées à l'initiation et à la clôture.</div></div>
      <div class="mon-card"><div class="mon-ico">📊</div><div class="mon-title">Qualité des données</div><div class="mon-desc">Vérifications internes périodiques. CRF papier ou eCRF selon ressources.</div></div>
      <div class="mon-card"><div class="mon-ico">🔐</div><div class="mon-title">Protection des données</div><div class="mon-desc">Respect CNIL / RGPD obligatoire. Non-opposition ou consentement selon catégorie RIPH.</div></div>
    </div></div>`
};

function showResult(resId){
  const r=T().results[resId];
  if(!r){renderHome();return;}
  const monLvl=r.mon;
  const nextMods={reglem:'methodo',methodo:'bpc'};
  $mc().innerHTML=`
  <div class="results-screen anim">
    <div class="res-header">
      <div class="check-circle">✓</div>
      <h2>Résultats de l'analyse</h2>
      <p>Recommandations adaptées à votre projet de recherche</p>
    </div>
    <div class="classif-card ${r.cls}">
      <div class="classif-cat">${r.cat}</div>
      <div class="classif-title">${r.title}</div>
      <div class="classif-desc">${r.sum}</div>
      ${monLvl?`<div class="classif-mon">${MON_LABEL[monLvl]}</div>`:''}
    </div>
    <div class="section-title">📋 Démarches et étapes obligatoires</div>
    <div class="timeline">
      ${r.steps.map(s=>`
        <div class="tl-item">
          <div class="tl-dot ${s.req?'req':'opt'}"></div>
          <div class="tl-card">
            <div class="tl-ico">${s.ic}</div>
            <div>
              <div class="tl-name">${s.n}<span class="badge ${s.req?'req':'opt'}">${s.req?'Obligatoire':'Recommandé'}</span></div>
              <div class="tl-detail">${s.d}</div>
            </div>
          </div>
        </div>`).join('')}
    </div>
    ${monLvl&&MON_GRIDS[monLvl]?MON_GRIDS[monLvl]:''}
    ${r.refs&&r.refs.length?`
    <hr class="divider">
    <div class="section-title">🔗 Références réglementaires</div>
    <div class="ref-links">
      ${r.refs.map(rf=>`<a class="ref-link" href="${rf.u}" target="_blank">📄 ${rf.t}</a>`).join('')}
    </div>`:''}
    <div class="restart-section">
      <button class="btn-primary" onclick="startModule('${state.mod}')">↺ Recommencer ce module</button>
      ${nextMods[state.mod]?`<button class="btn-ghost" onclick="startModule('${nextMods[state.mod]}')">Module suivant : ${TREES[nextMods[state.mod]].label} →</button>`:''}
      <button class="btn-ghost" onclick="renderHome();document.querySelectorAll('.tab-btn').forEach(b=>b.classList.toggle('active',b.dataset.tab==='home'))">🏠 Accueil</button>
    </div>
  </div>`;
}

/* ─── INIT ─── */
renderHome();
